import { ErrorOutline, KeyboardArrowDown } from "@mui/icons-material";
import {
  Button,
  CircularProgress,
  Dialog,
  InputBase,
  MenuItem,
  Select,
} from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import validator from "validator";
import decryptApi from "../utils/decryptApi";
import encryptApi from "../utils/encryptApi";

const RequireTwilioAccountModal = ({ open, setOpen, step, setStep }) => {
  const [channel, setChannel] = useState({
    channel_type: "email",
  });

  const [loader, setLoader] = useState(false);
  const [errorMsg, setErrormsg] = useState(null);

  const addTestTwilioInformation = async () => {
    console.log(JSON.parse(localStorage.getItem("organization"))
    .organization_name.S)

    
    console.log(
      {
        organization_id: JSON.parse(localStorage.getItem("organization"))
          .orgId.S,
        account_sid: process.env.REACT_APP_ACCOUNT_SID,
        api_key: process.env.REACT_APP_API_KEY,
        transcription_enabled: false,
        test_account: true,
        auto_configuration: true,
        //primary_phone: newNumber.data.phoneNumber,
      }
    )


    
    try {
      const validAreaCodes = [
        415, 212, 305, 408, 702, 213, 718, 512, 404, 312,
        // Add more area codes as needed
      ];
    
      // Randomly pick an area code from the array
      const randomIndex = Math.floor(Math.random() * validAreaCodes.length);
      
  
      setLoader(true);
      let newNumber = await axios.post(
        process.env.REACT_APP_BACKEND_URL + "twilio/create-incoming-phone-number",
        {
          account_sid: process.env.REACT_APP_ACCOUNT_SID,
          api_key: process.env.REACT_APP_API_KEY,
          organization_name: JSON.parse(localStorage.getItem("organization"))
            .organization_name.S,
          area_code :  validAreaCodes[5]
        }
      );
  
  
      if (validator.isMobilePhone(newNumber.data.phoneNumber)) {
        
        await axios
          .post(
            process.env.REACT_APP_BACKEND_URL + "add-org-twilio_information",
            {
              organization_id: JSON.parse(localStorage.getItem("organization"))
                .orgId.S,
              account_sid: process.env.REACT_APP_ACCOUNT_SID,
              api_key: process.env.REACT_APP_API_KEY,
              transcription_enabled: false,
              test_account: true,
              auto_configuration: true,
              primary_phone: newNumber.data.phoneNumber,
            }
          )
          .then((res) => {
            if (res.data.status ===  "success") {
              console.log(res.data);
              localStorage.setItem(
                "organization",
                JSON.stringify(res.data.organization)
              ); //stores organization datat in local storage
              setLoader(false);
              setStep(step + 2);
            } else {
              setErrormsg("some error occured try again");
              setLoader(false);
            }
          })
          .catch((err) => {
            setErrormsg(err);
            setLoader(false);
          });
      }else{
        setErrormsg("some error with your credentials occured");
        setLoader(false);
      }
    } catch (error) {
      setLoader(false)
      console.log(error)
     if(error.response.data && error.response.data.error){

      setErrormsg(error.response.data.error)
     }
   

    }
  };

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={"sm"}
      BackdropProps={{
        style: { backgroundColor: "rgba(0, 0, 0, 0.2)" }, // Adjust opacity here
      }}
    >
      <div className="lg:px-8 px-4 py-6">
        <div className="lg:text-[20px] text-[#030229]  text-[15px] font-semibold  text-center mb-4">
          {" "}
          Twilanswer Requires Twilio
        </div>

        {errorMsg && (
          <div className="text-center text-red-500 lg:text-[13px] text-[12px] mt-2  font-semibold ">
            <ErrorOutline sx={{ fontSize: "" }} /> {errorMsg}
          </div>
        )}

        <div className="lg:text-[14px] text-[13px] text-center">
          Twilanswer integrates with your Twilio account to manage numbers and
          pay for minutes. If you’re just looking to test Twilanswer out, we can
          grant you temporary access to a test number without integrating an
          account.
        </div>

        <div className="flex items-center justify-center space-x-3 mt-4">
          <Button
            sx={{
              textTransform: "none",
              bgcolor: "white",
              color: "#605BFF",
              py: "6px",
              px: "30px",
              borderRadius: "7px",
              border: "1px solid rgba(96,91,255,0.1)",
              fontSize: { lg: "14px", xs: "13px" },
              width: "fit",
            }}
            onClick={() => 
            {
              setErrormsg(null)
              setOpen(false)
            }
            }
          >
            Back
          </Button>
          <Button
            sx={{
              textTransform: "none",
              bgcolor: "rgba(96,91,255,0.1)",
              color: "#605BFF",
              py: "6px",
              px: "30px",
              borderRadius: "7px",
              fontSize: { lg: "14px", xs: "13px" },
              width: "fit",
            }}
            onClick={() => addTestTwilioInformation()}
            disabled={loader}
          >
            {loader ? (
              <CircularProgress size={"1.3rem"} sx={{ color: "white" }} />
            ) : (
              " Proceed with Test Number"
            )}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default RequireTwilioAccountModal;
